import classNames from 'classnames';
import { Button } from 'palette/Button';

import '../styles/CMSCarouselButton.scss';

function CMSCarouselButton({ direction, blockId }) {
    const isNext = direction === 'next';

    const handleClick = () => {
        const element = document.querySelector(`div[data-id="${blockId}"] .cms-product-template--one`);

        if (element) {
            const { clientWidth, scrollWidth, dataset } = element;
            const scrollStep = Number(dataset.scrollStep || 1);
            const parent = element.parentNode;
            const newScrollStep = direction === 'next' ? scrollStep + 1 : scrollStep - 1;
            const prevElement = parent.querySelector('.cms-carousel__button--prev');

            element.dataset.scrollStep = String(newScrollStep);

            if (direction === 'next') {
                element.scrollLeft = newScrollStep * clientWidth;
                prevElement.classList.add('cms-carousel__button--visible');

                const firstProduct = element.querySelector('.cms-product-template__item');
                let additionalWidth = 0;

                if (firstProduct) {
                    additionalWidth = firstProduct.clientWidth;
                }

                if ((scrollWidth - additionalWidth) <= ((scrollStep + 2) * clientWidth)) {
                    parent
                        .querySelector('.cms-carousel__button--next')
                        .classList
                        .remove('cms-carousel__button--visible');
                }
            } else {
                if ((scrollStep - 2) >= 0) {
                    parent
                        .querySelector('.cms-carousel__button--next')
                        .classList
                        .add('cms-carousel__button--visible');
                }

                element.scrollLeft = (newScrollStep - 1) * clientWidth;

                if ((scrollStep - 2) <= 0) {
                    prevElement.classList.remove('cms-carousel__button--visible');
                }
            }
        }
    };

    return (
        <Button
            isTransparent
            className={classNames('cms-carousel__button', {
                'cms-carousel__button--next': isNext,
                'cms-carousel__button--prev': !isNext,
                'cms-carousel__button--visible': direction === 'next'
            })}
            iconName={direction === 'next' ? 'palette_chevron_right' : 'palette_chevron_left'}
            svgUrl={App.Config.svgUrl}
            theme="secondary"
            onClick={handleClick}
        />
    );
}

export default CMSCarouselButton;
